const AUTH_ERROR_PATTERN = /authorization|auth fail/i;
const refreshRequests = new Map();

const redirectToLogin = () => {
  if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
    window.location.assign('/login');
  }
};

const getRefreshKey = (client) => client.defaults.baseURL || 'default';

const isSuccessfulRefresh = (response) => {
  const isSuccessfulStatus = response?.status >= 200 && response?.status < 300;
  const businessStatus = response?.data?.status;

  return isSuccessfulStatus && (!businessStatus || businessStatus === 'success');
};

const refreshSession = (client) => {
  const refreshKey = getRefreshKey(client);
  const existingRequest = refreshRequests.get(refreshKey);

  if (existingRequest) {
    return existingRequest;
  }

  const request = client.post('/admin/auth/refresh-token').finally(() => {
    if (refreshRequests.get(refreshKey) === request) {
      refreshRequests.delete(refreshKey);
    }
  });

  refreshRequests.set(refreshKey, request);
  return request;
};

export const configureAuthInterceptor = (client, { redirectOnFailure = true } = {}) => {
  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error.response?.status;
      const message = error.response?.data?.msg;
      const isRefreshRequest = originalRequest?.url?.includes('refresh-token');
      const isLoginRequest = originalRequest?.url?.includes('/admin/auth/login');
      const isAuthError = status === 401 ||
        (status === 403 && (!message || AUTH_ERROR_PATTERN.test(message)));

      if (!originalRequest || !isAuthError || isRefreshRequest || isLoginRequest || originalRequest._retry) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        const refreshResponse = await refreshSession(client);
        if (isSuccessfulRefresh(refreshResponse)) {
          return client(originalRequest);
        }
      } catch (refreshError) {
        // The original authentication error is more useful to callers.
      }

      if (redirectOnFailure) {
        redirectToLogin();
      }

      return Promise.reject(error);
    }
  );

  return client;
};
